// extracted by mini-css-extract-plugin
module.exports = {"Waffle":"WaffleButton__Waffle__3uu7a","active":"WaffleButton__active__QEpYs","NavigationItems":"WaffleButton__NavigationItems__3s7NJ"};